import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Breadcrumbs, ButtonBase, Checkbox, Divider, FormHelperText, Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Notification from "../../components/Common/Notification";
import LoadingDialog from "../../components/Common/LoadingDialog"; import Label from "../../components/Common/Label";
import "../Support/support.css";
import Breadcrumb from "../../components/Common/Breadcrumb";
import CustomButton from "../../components/Form/CustomButton";
import AppRating from "../../components/Common/AppRating";
import AppDialog from "../../components/Common/AppDialog";
import { getReviewApproval, getReviewDetails, resetReviewState } from "../../store/actions";
import '../Orders/order.css'
import Helpers from "../../helpers/helpers";


const ViewReview = ({ userPermission, reviewDetails, reviewApproval }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { ID } = useParams();

    const [loading, setIsLoading] = useState(false);
    const [publishReviewOpen, setPublishReviewOpen] = useState(false);
    const [rejectReviewOpen, setRejectReviewOpen] = useState(false);
    const [reviewStatus, setReviewStatus] = useState('pending_approval');
    const [viewSpecs, setViewSpecs] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);

    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [approvaeble, setApproveable] = useState(false);

    useEffect(() => {
        dispatch(resetReviewState());
        initData();

        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);

        return (() => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        })
    }, [])

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("approve-review") && setApproveable(true);
            !userPermission?.includes("view-review") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        if (reviewApproval?.code === 'success') {
            setNotification({ open: true, msg: rejectReviewOpen ? 'Review rejected.' : 'Review published', type: 'success' });
            setRejectReviewOpen(false);
            setPublishReviewOpen(false);
            dispatch(resetReviewState());
            initData();
        } else if (reviewApproval?.code === 'invalid_status') {
            setNotification({ open: true, msg: 'Invalid status', type: 'error' });
            setRejectReviewOpen(false);
            setPublishReviewOpen(false);
            dispatch(resetReviewState());
            initData();
        }
        setIsLoading(false);
    }, [reviewApproval])

    const initData = () => {
        if (ID)
            dispatch(getReviewDetails({ id: ID }));
    }

    const rejectReview = () => {
        setIsLoading(true);
        dispatch(getReviewApproval({ id: ID, data: { status: 'rejected' } }));
    }

    const publishReview = () => {
        setIsLoading(true);
        dispatch(getReviewApproval({ id: ID, data: { status: 'approved' } }));
    }

    const publishReviewModal = () => {
        return (
            <AppDialog
                open={publishReviewOpen}
                close={() => setPublishReviewOpen(false)}
                title="Publish review"
                titleIcon="complete"
                positiveTitle="Publish"
                positivePress={() => publishReview()}
                positiveButtonStyle={{ color: 'white', backgroundColor: '#34C759', border: '1px solid #34C759' }}
                negativeTitle="Cancel"
                negativePress={() => setPublishReviewOpen(false)}
                width={'40%'}
            >
                Are you sure you want to publish this product review to your e-commerce platform?
            </AppDialog>
        )
    }

    const rejectReviewModal = () => {
        return (
            <AppDialog
                open={rejectReviewOpen}
                close={() => setRejectReviewOpen(false)}
                title="Reject review"
                titleIcon="reject"
                positiveTitle="Reject"
                positivePress={() => rejectReview()}
                positiveButtonStyle={{ color: 'white', backgroundColor: '#44d62c', border: '1px solid #44d62c' }}
                negativeTitle="Cancel"
                negativePress={() => setRejectReviewOpen(false)}
                width={'40%'}
            >
                Are you sure you want to reject this product review? Rejected review won{"\'"}t be displayed on e-commerce platform.
            </AppDialog>
        )
    }
    return (
        <React.Fragment>
            {
                approvaeble && width <= 425 &&
                <div className="mobile-button-container d-flex justify-content-between">
                    {
                        (reviewDetails?.status === 'pending_approval' || reviewDetails?.status === 'approved') &&
                        <CustomButton
                            title={'Reject'}
                            backgroundColor={'transparent'}
                            textColor={'#44d62c'}
                            borderStyle={'1px solid #44d62c'}
                            press={() => setRejectReviewOpen(true)}
                            marginRight={10}
                            width={'50%'}
                        />
                    }
                    {
                        (reviewDetails?.status === 'pending_approval' || reviewDetails?.status === 'rejected') &&
                        <CustomButton
                            title={'Publish'}
                            backgroundColor={'#34C759'}
                            textColor={'white'}
                            borderStyle={'1px solid #34C759'}
                            press={() => setPublishReviewOpen(true)}
                            width={'50%'}
                        />
                    }
                </div>
            }
            <div className="page-content">
                <LoadingDialog open={loading || !reviewDetails} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumb
                        backRoute="/review"
                        breadcrumbItems={[{ title: "Review", link: "/review" },
                        { title: reviewDetails?.status === "pending_approval" ? 'Review Approval' : 'Review Details', link: "#" },
                        ]}
                    >{approvaeble && width > 425 &&
                        <div >
                            {
                                (reviewDetails?.status === 'pending_approval' || reviewDetails?.status === 'approved') &&
                                <CustomButton
                                    title={'Reject'}
                                    backgroundColor={'transparent'}
                                    textColor={'#44d62c'}
                                    borderStyle={'1px solid #44d62c'}
                                    press={() => setRejectReviewOpen(true)}
                                    marginRight={10}
                                />
                            }
                            {
                                (reviewDetails?.status === 'pending_approval' || reviewDetails?.status === 'rejected') &&
                                <CustomButton
                                    title={'Publish'}
                                    backgroundColor={'#34C759'}
                                    textColor={'white'}
                                    borderStyle={'1px solid #34C759'}
                                    press={() => setPublishReviewOpen(true)}
                                />
                            }
                        </div>}
                    </Breadcrumb>
                    <Card className="pb-3 px-1">
                        <CardBody>
                            <Grid container className="d-flex justify-content-between align-items-center">
                                <Grid item sm={6} xs={12} className="d-flex inquiry-header align-items-center">
                                    Order <Link className="mx-1 clickable-text" to={`/view-order/aspeed/${reviewDetails?.order_id}`}>#{reviewDetails?.order_id || ''}</Link>
                                </Grid>
                                <Grid item sm={6} xs={12} className="inquiry-description d-flex align-items-center" sx={{ justifyContent: { xs: 'start', sm: 'end' } }}>
                                    {reviewDetails?.customer_name || 'N/A'}
                                    <i className="ri-checkbox-blank-circle-fill mx-1" style={{ fontSize: 7 }} />
                                    {reviewDetails?.created_date || ''}
                                </Grid>
                            </Grid>

                            <Divider className="mt-3 mb-4" />
                            <div className="curve-container">
                                <Grid container spacing={1} >
                                    <Grid item sm={1} className="inquiry-section-title">
                                        <img src={reviewDetails?.product?.thumbnail_image || Helpers.noImageLink} alt="product-image" style={{ width: "100%", height: "60px", objectFit: 'contain' }} />
                                    </Grid>
                                    <Grid item sm={11} className="d-flex align-items-center">
                                        <div>
                                           <div className="d-flex">{reviewDetails?.product?.name || ''} <Label.ItemTag label={reviewDetails?.product?.product_type || 'simple'} /></div>
                                        <div className="inquiry-description">SKU: {reviewDetails?.product?.sku || ''}</div>
                                        {
                                            reviewDetails?.product?.specs?.length > 0 &&
                                            <>
                                                <div className="clickable-text mt-2" onClick={() => setViewSpecs(!viewSpecs)}>{viewSpecs ? 'Hide Specs' : 'View Specs'}</div>
                                                {
                                                    viewSpecs &&
                                                    <div className="mt-1 mb-3" style={{ color: '#686868', fontSize: 12 }}>
                                                        {
                                                            reviewDetails?.product?.specs?.length > 0 && reviewDetails?.product?.specs.map((spec, index) => {
                                                                return (
                                                                    <li><span style={{ fontFamily: 'Manrope-Bold' }}>{spec?.configuration_name}</span>: {spec?.display_name}</li>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                }
                                            </>
                                        } 
                                        </div>
                                        
                                    </Grid>
                                </Grid>
                            </div>
                            <div className="mt-3 d-flex">
                                <AppRating rating={reviewDetails?.rating || 0} />
                                <Label.ReviewStatusLabel label={reviewDetails?.status || 'pending_approval'} />
                            </div>
                            <div className="mt-2 d-flex">
                                {reviewDetails?.comments || 'No comments'}
                            </div>
                        </CardBody>
                    </Card>
                    {publishReviewModal()}
                    {rejectReviewModal()}
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Review }) {
    return {
        userPermission: Login.permissionArry,
        reviewDetails: Review.reviewDetails.data,
        reviewApproval: Review.reviewApproval,
    };
}

export default connect(mapStateToProps)(ViewReview);
